export const Creators = {
    animateMenu: (option) => ({
        type: option
    })
}

